import { Grid, Skeleton } from '@mantine/core';
import React from 'react';
import XTextStackInfo from '../x-text-stack-info.component';

function XSkeleton3Fields(props: Props) {
  const { skeletonHeight, skeletonWidth } = props;
  const height = skeletonHeight ?? 14;
  const width = skeletonWidth ?? '100%';
  return (
    <>
      <Grid.Col xs={3}>
        <XTextStackInfo
          label={<Skeleton height={height} width={'50%'} />}
          value={<Skeleton height={height} width={width} />}
        />
      </Grid.Col>
      <Grid.Col xs={1}></Grid.Col>
      <Grid.Col xs={3}>
        <XTextStackInfo
          label={<Skeleton height={height} width={'50%'} />}
          value={<Skeleton height={height} width={width} />}
        />
      </Grid.Col>
      <Grid.Col xs={1}></Grid.Col>
      <Grid.Col xs={3}>
        <XTextStackInfo
          label={<Skeleton height={height} width={'50%'} />}
          value={<Skeleton height={height} width={width} />}
        />
      </Grid.Col>
      <Grid.Col xs={1}></Grid.Col>
    </>
  );
}

interface Props {
  skeletonHeight?: number;
  skeletonWidth?: number | string;
}

export default XSkeleton3Fields;
